/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imageorderupdated2Inputs */

const en_imageorderupdated2 = /** @type {(inputs: Imageorderupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image order updated`)
};

const de_imageorderupdated2 = /** @type {(inputs: Imageorderupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildreihenfolge aktualisiert`)
};

/**
* | output |
* | --- |
* | "Image order updated" |
*
* @param {Imageorderupdated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imageorderupdated2 = /** @type {((inputs?: Imageorderupdated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imageorderupdated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imageorderupdated2(inputs)
	return de_imageorderupdated2(inputs)
});
export { imageorderupdated2 as "imageOrderUpdated" }